import { css } from 'styled-components';

import { mapControlWidth, mapControlBg } from './constants';

export const LayersControls = css`
  .lt-map-layers-controls {
    position: absolute;
    z-index: 4;
    top: 140px;
    left: 10px;

    .map-layers-control__demo {
      width: 100%;
    }

    .lt-map-layers-controls__buttons {
      display: flex;
      flex-direction: column;
    }

    .lt-map-layers-controls__button {
      width: ${mapControlWidth};
      height: ${mapControlWidth};
      background: ${mapControlBg};
      border: 0;

      &:first-child {
        border-top-left-radius: ${mapControlWidth};
        border-top-right-radius: ${mapControlWidth};
      }

      &:last-child {
        border-bottom-right-radius: ${mapControlWidth};
        border-bottom-left-radius: ${mapControlWidth};
      }

      &[disabled] {
        background: none;

        svg {
          stroke: #919499;
        }
      }
    }

    .lt-map-layers-controls--disabled {
      .lt-map-layers-controls__buttons {
        border-radius: ${mapControlWidth};
        box-shadow: inset 0 0 0 1px #919499;
      }
    }

    .lt-map-layers-controls-button {
      svg {
        stroke: #444;
        width: 24px;
        height: 24px;
      }
    }

    .lt-map-layers-controls-button__drink {
      .lt-icons {
        position: relative;
        top: 0;
        left: -3px;
        height: 25px !important;
      }
    }

    .lt-map-layers-controls-button__drink--active {
      background-color: #ffc20d;

      svg {
        stroke: #fff;
      }
    }

    .lt-map-layers-controls-button__drink--active {
      background-color: #ffc20d;

      svg {
        stroke: #fff;
      }
    }

    .lt-map-layers-controls-button__museum--active {
      background-color: #214ca3;

      svg {
        stroke: #fff;
      }
    }

    .lt-map-layers-controls-button__shopping--active {
      background-color: #25d97f;

      svg {
        stroke: #fff;
      }
    }
  }
`;
